import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderActionService {
  isLoadingSubject: BehaviorSubject<boolean | any> = new BehaviorSubject<boolean | any>(
    false
  );

  isLoading = this.isLoadingSubject.asObservable();

  constructor(private route: ActivatedRoute, private router: Router) { }

  /**
   * @description Hiển thị Activity Indicator
   */
  showActivityIndicator() {
    const param = this.route.snapshot.queryParams
    if (param && param.pId === "0" || this.router.url.includes('report')) {
      this.isLoadingSubject.next(true);
    }
  }

  /**
   * @description Hiển thị Activity Indicator
   */
  showActivityIndicator360() {
    const loadingKey = [
      // { key: CUSTOMER, isLoading: true },
      // { key: ACCOUNT, isLoading: true },
      // { key: EMB, isLoading: true },
      // { key: CARD, isLoading: true },
      // { key: LOAN_AMOUNT, isLoading: true },
      // { key: SMS, isLoading: true },
      // { key: PKG, isLoading: true }

    ]
    this.isLoadingSubject.next(loadingKey);
  }

  /**
   * @description Ẩn Activity Indicator
   */
  hideActivityIndicator() {
    this.isLoadingSubject.next(false);
  }

  /**
   * @description Ẩn Activity Indicator
   */
  hideActivityIndicator360(key) {
    const isLoadingValue = this.isLoadingSubject.value;
    if(isLoadingValue){
      const object = isLoadingValue.find(x => x.key === key);
      if (object) {
        object.isLoading = false;
      }
      this.isLoadingSubject.next(isLoadingValue);
    }
  }
}
